<page-toolbar [pageActions]="pageActions" title="{{'myUsers.group.editTitle' | translate}}: {{groupName}}"></page-toolbar>

<page-content>
  <div class="table">
    <data-table (remove)="removeProfile($event)" [columns]="columns" [dataProviderParams]="params" [hideSearch]="true"
                [dataProvider]="groupHasFrontProfilesService" [title]="'myUsers.profileAssignment' | translate"></data-table>
    <button (click)="addProfiles()" class="add-button" color="primary" mat-mini-fab>
      <mat-icon class="mat-24">add</mat-icon>
    </button>
  </div>
</page-content>
